import { IOrderTargetMargin } from '@AMIEWEB/Order/Store/Order.redux';
import { missingField } from 'app/constants';

export const getAmount = (value: number | null | undefined) => {
  return value == null || value == undefined ? missingField : `$${value.toFixed(2)}`;
};

export const getPercentage = (value: number | null | undefined) => {
  return value == null || value == undefined ? missingField : `${value.toFixed(2)}%`;
};

export const validatePercentage = (value: string) => /^(\d{1,3})(\.\d{0,2})?$/.test(value) && parseFloat(value) <= 100;

export const validateAmount = (value: string) => /^(\d{1,6})(\.\d{0,2})?$/.test(value) || value === '';

export const coerceRowValues = (row: any): Partial<IOrderTargetMargin> => ({
  subSpecialty: row.subSpecialty == missingField ? null : row.subSpecialty,
  targetMarginDefault: Number(row.targetMarginDefault),
  targetMarginDayShift: Number(row.targetMarginDayShift),
  targetMarginNightShift: Number(row.targetMarginNightShift),
  targetMarginDayNightShift: Number(row.targetMarginDayNightShift),
  payRangeMinMaxPercentage: Number(row.payRangeMinMaxPercentage),
  defaultWeeklyPay: Number(row.defaultWeeklyPay),
});
